import { parseDomain, fromUrl } from 'parse-domain';

export const toHome = () => {
  location.href = '/';
};

export async function hashAndTrim(
  input: string,
  length: number = 15,
): Promise<string> {
  // Кодируем строку в Uint8Array
  const encoder = new TextEncoder();
  const data = encoder.encode(input);

  // Хешируем с помощью SHA-256 (можно заменить на другой алгоритм)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  // Преобразуем хеш в hex-строку
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

  // Обрезаем до нужной длины (по умолчанию 15 символов)
  return hashHex.substring(0, length);
}

/**
 * Валидирует URL строку
 * @param {string} url - Строка для проверки
 * @param {Object} options - Опции валидации
 * @param {boolean} options.requireProtocol - Обязательно наличие протокола (http/https)
 * @param {boolean} options.requireValidTld - Обязательно наличие валидного домена верхнего уровня
 * @param {string[]} options.allowedProtocols - Разрешенные протоколы (по умолчанию ['http:', 'https:'])
 * @returns {boolean} - Результат валидации
 */
export function isValidUrl(
  url: string,
  options: {
    requireProtocol?: boolean;
    requireValidTld?: boolean;
    allowedProtocols?: string[];
  } = {},
): boolean {
  const {
    requireProtocol = true,
    requireValidTld = true,
    allowedProtocols = ['http:', 'https:'],
  } = options;

  try {
    // Создаем URL объект (выбросит исключение при невалидном URL)
    const urlObj = new URL(url);

    // Проверяем протокол
    if (requireProtocol && !allowedProtocols.includes(urlObj.protocol)) {
      return false;
    }

    // Проверяем домен верхнего уровня
    if (requireValidTld) {
      const domainParts = urlObj.hostname.split('.');
      if (domainParts.length < 2 || !domainParts[domainParts.length - 1]) {
        return false;
      }
    }

    return true;
  } catch (err) {
    return false;
  }
}

export function isRelativeUrl(url: string): boolean {
  return /^\.{0,2}\//.test(url) || !/^[a-z][a-z0-9+.-]*:/.test(url);
}

export function isValidDomain(hostname: string): boolean {
  const parsed = parseDomain(fromUrl(hostname));
  return !!parsed && !!parsed.hostname;
}

export function hasValidTld(hostname: string): boolean {
  const parsed = parseDomain(fromUrl(hostname));
  return !!parsed && !!parsed.topLevelDomains;
}

export async function isUrlAvailable(url: string): Promise<boolean> {
  try {
    const response = await fetch(url, {method: 'HEAD'});
    return response.ok;
  } catch {
    return false;
  }
}
